import { GO_TO_AGENT_COMM, GO_TO_AGENT_LUX, GO_TO_AGENT_RES } from './../../../classes/analytics-tags';
import { CommunicationService } from './../../../services/communication.service';
import {Component, EventEmitter, Input, Output, ViewChild, SimpleChanges, OnChanges} from '@angular/core';
import {Agent} from '../../../classes/agent';
import {CircleInitialsComponent} from '../../circle-initials/circle-initials.component';
import { ListingCategory } from '../../../classes/enums';
import { Angulartics2 } from 'angulartics2';
import { RankMyAgentService } from '../../../services/rank-my-agent.service';
import { AgentRating } from '../../../classes/agentRating';
import { Router } from '@angular/router';
import {delay} from "rxjs/operators";

@Component({
  selector: 'app-agent-card',
  templateUrl: './agent-card.component.html',
  styleUrls: ['./agent-card.component.scss', './agent-card.mobile.scss', 'agent-card.desktop.luxury.component.scss']
})
export class AgentCardComponent implements OnChanges {
  // Whether to include the title for the agent
  @Input() includeTitle: boolean = false;
  @Input() agent: Agent;
  @Input() readonly isLDP: boolean = false;
  @Input() isLuxury: boolean = false;
  @Input() isRedesign: boolean = false;
  @Input() readonly enableAnalyticsEventTriggering: boolean = false; // When we want to trigger a custom event trigger for the contact information
  @Output() onContactAgent: EventEmitter<Agent> = new EventEmitter<Agent>();
  @Output() onAgentEmailClicked: EventEmitter<Agent> = new EventEmitter<Agent>();

  @ViewChild(CircleInitialsComponent) circleInitialsComponent: CircleInitialsComponent;

  shouldShowInitials: boolean = false;
  agentRating: AgentRating;

  constructor(
    private communicationService: CommunicationService,
    private rankService: RankMyAgentService,
    private angulartics2: Angulartics2,
    private router: Router,
  ) { }

  ngOnChanges(s: SimpleChanges) {
    if (!s.agent) return;

      this.rankService.getAgentRating(s.agent.currentValue.personifyId).pipe(delay(0)).toPromise()
        .then(rating => this.agentRating = rating ? rating['result'] : null);

  }

  /**
   * On fails for retrieving the agent profile image, we want to use their initials instead
   * @param event
   */
  imgErrorHandler(event) {
    this.shouldShowInitials = true;
  }

  stopPropagation(event) {
    event.stopPropagation();
  }

  /**
   * When they click the email on the agent card, we want to track that event on google analytics for certain pages
   * ex: on the popular real estate agent pages
   * random comment
   */
  trackEmailClickAnalytics() {
    if (!this.enableAnalyticsEventTriggering) return;

    this.angulartics2.eventTrack.next({
      properties: {
        event: 'email_a_agent_agentcitypage'
      }
    });
  }

  sendNavigateAnalyticsEvent() {
    let tagName = null;
    if (!this.isLDP) {
      return;
    }
    if (this.isLuxury) {
      tagName = GO_TO_AGENT_LUX;
    } else {
      switch (this.communicationService.listings.currentShownListingType.value) {
        case ListingCategory.COMMERCIAL:
          tagName = GO_TO_AGENT_COMM;
          break;
        case ListingCategory.LUXURY:
          tagName = GO_TO_AGENT_LUX;
          break;
        case ListingCategory.RESIDENTIAL:
          tagName = GO_TO_AGENT_RES;
          break;
      }
    }

    this.angulartics2.eventTrack.next({
      properties: {
        event: tagName
      }
    });
  }

  goToAgent(event?: Event, parentElement?) {
    if (!event || !parentElement || event.target === parentElement) { // Necessary to prevent navigation to agent page when hitting 'enter' on the agents email
      this.sendNavigateAnalyticsEvent();
      this.router.navigate([this.agent.detailUrl]);
    }
  }
}
